/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Last_Month_FilterInputs */

const en_last_month_filter = /** @type {(inputs: Last_Month_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last month`)
};

const nl_last_month_filter = /** @type {(inputs: Last_Month_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afgelopen maand`)
};

/**
* | output |
* | --- |
* | "Last month" |
*
* @param {Last_Month_FilterInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const last_month_filter = /** @type {((inputs?: Last_Month_FilterInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Last_Month_FilterInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_last_month_filter(inputs)
	return en_last_month_filter(inputs)
});